




















































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsRadio extends Vue {
  private vradio0 = true;
  private vradio1 = '';
  private vradio2 = 'checked';
  private vradio3 = -1;

  private fchange(val: boolean | number | string, e: MouseEvent): void {
    console.log(val, e);
  }
}
